module.exports = __webpack_public_path__ + "static/grbmember7-b4bfa7573587ec5a28b8ce732e8d1a20.png";